module.exports = __webpack_public_path__ + "zvetseni-prsou_56_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_56_before.jpg
// module id = 1350
// module chunks = 0